import microsoft from '../../../images/microsoft.png';
import exxon from '../../../images/exxon.png';
import meta from '../../../images/meta.png';
import nvidia from '../../../images/nvidia.png';


export const companiesLogos = [
    {logo: microsoft},
    {logo: exxon},
    {logo: meta},
    {logo: nvidia},
    {logo: microsoft},
    {logo: exxon},
    {logo: meta},
    {logo: nvidia},
]
